import { apiFetch } from '../../lib/api/client.js';
import { storageKey } from '../../lib/storage-key.js';

export interface Announcement {
  id: string;
  title: string;
  body: string;
  pinned: boolean;
  publishFrom: string;
  publishTo: string | null;
  createdAt: string;
}

export const ANNOUNCEMENT_QUERY_KEYS = {
  active: ['announcements', 'active'] as const,
};

/**
 * Active announcements the viewer's tenancy node can see. `scope=received`
 * resolves the viewer node (x-agent-id) server-side and filters by sound
 * chain-membership; `active=true` restricts to the published window. Guest-safe:
 * the gateway stamps x-agent-id from the host even without a token.
 */
export async function fetchAnnouncements(): Promise<Announcement[]> {
  const res = await apiFetch<{ items: Announcement[] }>(
    '/announcements?scope=received&active=true&pageSize=20',
  );
  return res.items ?? [];
}

const SEEN_KEY = 'announcements.seen';

export function readSeen(): string[] {
  try {
    const raw = sessionStorage.getItem(storageKey(SEEN_KEY));
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function markSeen(ids: string[]): void {
  try {
    sessionStorage.setItem(storageKey(SEEN_KEY), JSON.stringify(ids));
  } catch {
    // storage unavailable (private mode) — dismissal just doesn't persist
  }
}
